import { render } from "./feed.vue?vue&type=template&id=ed1fe12a"
import script from "./feed.vue?vue&type=script&lang=js"
export * from "./feed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__